import { DataValidationError } from "constants/DataValidationError";
import {
  IsArray,
  IsBoolean,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  MaxLength,
} from "class-validator";
import Spec from "constants/Spec";

export default class CreateAdditionalTimeReq {
  @IsNotEmpty({
    message: DataValidationError.DATA_IS_EMPTY,
  })
  @IsNumber()
  totalFee!: number;

  @IsNotEmpty({
    message: DataValidationError.DATA_IS_EMPTY,
  })
  @IsNumber()
  shopFee!: number;

  @IsNotEmpty({
    message: DataValidationError.DATA_IS_EMPTY,
  })
  @IsNumber()
  castFee!: number;

  @IsNotEmpty({
    message: DataValidationError.DATA_IS_EMPTY,
  })
  @IsNumber()
  time!: number;

  @MaxLength(Spec.maxLength.additionalTime.name, {
    message: DataValidationError.DATA_IS_TOO_LONG,
    context: {
      constraint1: Spec.maxLength.additionalTime.name,
    },
  })
  name!: string;

  @IsOptional()
  @IsBoolean()
  isGuestShow!: boolean;

  @IsArray()
  shops!: number[];

  @IsArray()
  notelClasses!: number[];

  constructor(arg: any) {
    arg = arg || {};
    this.totalFee = arg.totalFee;
    this.shopFee = arg.shopFee;
    this.castFee = arg.castFee;
    this.time = arg.time;
    this.name = arg.name;
    this.isGuestShow = arg.isGuestShow;
    this.shops = arg.shops;
    this.notelClasses = arg.notelClasses;
  }
}
